import React from 'react';
import {
    Grid,
    FormControl,
    InputLabel,
} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import Button from "components/CustomButtons/Button.jsx";
import {EmptyRecord} from "../../../utils/PageUtility";
import SelectedRoutes from "../SelectedAirlineRoutes";
// import {appConstants} from "../../../_constants";
import AutocompleteSelect from "../../../utils/AutocompleteSelect";
import CircularProgress from "../../../utils/CircularProgress";

const styles = theme => ({
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "97%"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    selectInput: {
        marginTop: "0px",
        width: '97%'
    },
});

const SelectAirportComponent = ({disabled, classes, airports, Departure, Destination,
                                    selectedRoutes, selectChange, addSelectedRoute, removeSelectedRoute,
                                fetchingPreviousRoutes}) => {
    return (
        <div>
            <Grid container spacing={24}>
                <Grid item lg={5}>
                    <FormControl
                        className={classNames(classes.selectInput, classes.formControl)}
                    >
                        <InputLabel shrink htmlFor="age-label-placeholder">
                            Departure
                        </InputLabel>
                        <AutocompleteSelect
                            options={airports.map(option => ({value: option, label: option.Name}))}
                            name={"Departure"}
                            handleSelectChange={(e, name) => selectChange(e, name)}
                        />
                        {/*
                        <Select
                            value={Departure}
                            onChange={selectChange}
                            input={<Input name="airline" id="airline-label-placeholder" />}
                            // displayEmpty
                            name="Departure"
                            className={classes.selectEmpty}
                        >
                            <MenuItem value="-1">Select Departure</MenuItem>
                            {airports.map((option, i) => (
                                <MenuItem
                                    key={i}
                                    value={option}
                                    className={classes.select}
                                >
                                    {option.Name}
                                </MenuItem>
                            ))}
                        </Select>
                        */}
                    </FormControl>
                </Grid>
                <Grid item lg={5}>
                    <FormControl
                        className={classNames(classes.selectInput, classes.formControl)}
                    >
                        <InputLabel shrink htmlFor="age-label-placeholder">
                            Destination
                        </InputLabel>
                        <AutocompleteSelect
                            options={airports.map(option => ({value: option, label: option.Name}))}
                            name={"Destination"}
                            handleSelectChange={(e, name) => selectChange(e, name)}
                        />
                        {/*
                        <Select
                            value={Destination}
                            onChange={selectChange}
                            input={<Input name="airline" id="airline-label-placeholder" />}
                            // displayEmpty
                            name="Destination"
                            className={classes.selectEmpty}
                        >
                            <MenuItem value="-1">Select Departure</MenuItem>
                            {airports.map((option, i) => (
                                <MenuItem
                                    key={i}
                                    value={option}
                                    className={classes.select}
                                >
                                    {option.Name}
                                </MenuItem>
                            ))}
                        </Select>
                        */}
                    </FormControl>
                </Grid>
                <Grid item lg={2}>
                    &nbsp;
                    &nbsp;
                    <Button disabled={disabled} onClick={addSelectedRoute} size={'md'}>
                        Add
                    </Button>
                </Grid>
            </Grid>


            <div style={{marginTop: '15px'}}>
                {
                    (selectedRoutes.length > 0) &&
                    <SelectedRoutes
                        classes={classes}
                        routes={selectedRoutes}
                        removeSelectedRoute={removeSelectedRoute}
                    />
                }
                {fetchingPreviousRoutes &&  <CircularProgress />}
                {
                    (!fetchingPreviousRoutes && selectedRoutes.length === 0) &&
                    <EmptyRecord message={'No route selected yet!'}/>
                }
            </div>

        </div>
    );
};

export default withStyles(styles)(SelectAirportComponent);



// WEBPACK FOOTER //
// ./src/views/AirlineRouteSettings/steps/Airports.js